(function () {
    'use strict';

    angular
        .module('chamadosApp')
        .controller('AcaoController', AcaoController);

    AcaoController.$inject = ['$scope', '$state', 'Acao', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams', 'Alerta'];

    function AcaoController($scope, $state, Acao, ParseLinks, AlertService, paginationConstants, pagingParams, Alerta) {
        var vm = this;

        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.remover = remover;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.acoes;

        function loadAll() {
            Acao.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort(),
                filtro: vm.filtro
            }, onSuccess, onError);

            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.acoes = data;
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.page = pagingParams.page;
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        vm.loadAll();

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function remover(id) {
            Alerta.confirm("Atenção", "Tem certeza que deseja remover essa Ação?", "warning", function () {
                Acao.delete({id: id},
                    function () {
                        Alerta.success("Operação realizada", "O Ação foi removida!");
                        vm.loadAll();
                        $scope.$emit('chamadosApp:acaoUpdate');

                    });
            });
        }
    }
})();
